import React from 'react';
import {
  InsuranceDTO,
  PatientDTO,
} from 'dtos';
import Table from 'core/components/VirtualTable';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import columns from 'pages/Dashboard/pages/Appointments/pages/List/components/Details/PatientInsuranceList/columns';
import {
 useGetPatientInsurances,
} from 'views/EMR/components/Insurance/hooks';

export type ListProps = {
  encounterId?: number;
  patient?: PatientDTO;
  startDate?: string;
  endDate?: string;
  selectedInsuranceId?: number;
  onClose?: () => void;
};

export type InsuranceWithPatient = InsuranceDTO & Pick<ListProps, 'patient' | 'startDate' | 'endDate'>;

export default function InsuranceEligibilityList(props: ListProps) {
  const {
    patient,
    onClose,
    startDate,
    endDate,
  } = props;

  const {
    data: insurances,
  } = useGetPatientInsurances(patient?.patientId ?? 0);

  return (
    <div className="flex flex-col">
      <div className="flex gap-2 items-center justify-between px-2 bg-slate-200">
        <h3 className="text-xs font-semibold">Patient Insurances</h3>
        <IconButton onClick={() => { onClose?.(); }}>
          <CloseIcon className="!w-4 !h-4 !text-gray-600" />
        </IconButton>
      </div>
      <div className="flex flex-col w-full max-h-[300px]">
        <Table<InsuranceWithPatient>
          columns={columns}
          classes={{
            scrollContainer: '!pb-0',
            cell: '!items-end',
            row: '!items-center !px-2 !font-medium',
            header: '!px-2 !py-1 !border-t-0',
            outerRow: 'hover:!border-[#dde2ee] hover:rounded-none',
          }}
          data={(insurances ?? []).map((insurance) => ({
            ...insurance,
            patient,
            startDate,
            endDate,
          }))}
        />
      </div>
    </div>
  );
}
